import { navigateCart, navigateCheckout } from '../checkout/sagas';
import { navigateTrial } from '../trial/sagas';
import { ROUTES_ID, ROUTES_PATHS } from './constants';
import { buildRoutesMap, route } from './router';

export const routesMap = buildRoutesMap(
  route(ROUTES_ID.CART, ROUTES_PATHS[ROUTES_ID.CART], navigateCart),
  route(ROUTES_ID.CHECKOUT, ROUTES_PATHS[ROUTES_ID.CHECKOUT], navigateCheckout),
  route(ROUTES_ID.CONFIRMATION, ROUTES_PATHS[ROUTES_ID.CONFIRMATION]),
  route(
    ROUTES_ID.TRIAL_CONFIRMATION,
    ROUTES_PATHS[ROUTES_ID.TRIAL_CONFIRMATION],
  ),
  route(ROUTES_ID.TRIAL, ROUTES_PATHS[ROUTES_ID.TRIAL], navigateTrial),
);
